<template>
  <div class="sticky-toc">
    <div class="subhead-group subhead-b">
      <div
        v-for="(subsection, i) in this.subsections"
        :key="i"
        class="subhead-item"
      >
        <div
          v-if="subsection.SubsectionName[0] !== ''"
          class="subhead-item-text"
          @click="scrollToSubsection('cpd-subsection-b-' + i)"
          :id="'cpd-subsection-b-' + i"
        >
          {{subsection.SubsectionName[0]}}
        </div>
        <template v-if="subsection.Subsection">
          <div class="subhead-group subhead-c">
            <div
              v-for="(subsectionB, j) in subsection.Subsection"
              :key="'c-' + j"
              class="subhead-item"
            >
              <div
                v-if="subsectionB.SubsectionName[0] !== ''"
                class="subhead-item-text"
                @click="scrollToSubsection('cpd-subsection-c-' + i + '-' + j)"
                :id="'cpd-subsection-c-' + i + '-' + j"
              >
                {{subsectionB.SubsectionName[0]}}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: 'StickTOC',
  props: ['subsections'],
  methods: {
    scrollToSubsection (key) {
      const element = document.querySelector(`.cpd-subsection[id=${key}]`)
      const y = element.getBoundingClientRect().top + window.pageYOffset - 70

      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/variables.scss";
.sticky-toc {
  position: -webkit-sticky;
  position: sticky;
  top: 75px;
  margin-top: 20px;
  margin-left: -5px;
  padding-right: 5px;
  .subhead-group {
    color: #5b5b5b !important;
    .subhead-item {
      .subhead-item-text {
        margin: auto;
        vertical-align: middle;
        padding-top: 4px;
        padding-bottom: 4px;
        &:hover{
          background-color: #f2f2f2;
          border-left: 4px solid #f2f2f2;
          margin-left: -4px;
          cursor: pointer;
        }
        &:focus,
        &.active {
          background-color: #f2f2f2;
          border-left: 4px solid #00acc9;
          margin-left: -4px;
        }
      }
    }
  }
  .subhead-b {
    .subhead-item {
      .subhead-item-text {
        font-size: 15px;
        font-weight: 600;
        padding-left: 10px;
      }
      .subhead-c {
        .subhead-item {
          .subhead-item-text {
            font-size: 14px;
            font-weight: 400;
            padding-left: 20px;
          }
        }
      }
    }
  }
}
</style>
